export type Body = {
  x: number;
  y: number;
  vx: number;
  vy: number;
  angle: number;
  angularVelocity: number;
  width: number;
  height: number;
  mass: number;
  restitution: number;
};

export function createBody(partial: Partial<Body> & Pick<Body, 'x' | 'y' | 'width' | 'height'>): Body {
  return {
    vx: 0,
    vy: 0,
    angle: 0,
    angularVelocity: 0,
    mass: 1,
    restitution: 0.35,
    ...partial,
  };
}

export function normalizeAngle(radians: number): number {
  let a = radians % (Math.PI * 2);
  if (a > Math.PI) a -= Math.PI * 2;
  if (a < -Math.PI) a += Math.PI * 2;
  return a;
}

export function shortestAngleDelta(from: number, to: number): number {
  return normalizeAngle(to - from);
}
